import { Component, AfterViewInit, ElementRef, Renderer2, ViewChild, OnInit } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';
import { environment } from '../../../environments/environment';
import { Router, RouterLink } from '@angular/router';

interface IHomePageUSP{
  title: string;
  val: string;
}

@Component({
  selector: 'app-hero',
  imports: [RouterLink],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss'
})
export class HeroComponent implements AfterViewInit, OnInit {
  @ViewChild('heroRef', { static: true }) heroRef!: ElementRef;

  homePageUSP: IHomePageUSP[] = [];

  constructor(private renderer: Renderer2, private http: HttpService, private router: Router) {}


  ngOnInit(): void {
    this.http.get<IHomePageUSP[]>(`${environment.API_ENDPOINT}/api/home/usp`).subscribe(res => {
      this.homePageUSP = res;
    })
  }



  ngAfterViewInit(): void {
    const elements: NodeListOf<HTMLElement> = this.heroRef.nativeElement.querySelectorAll('.animate-on-load');
    elements.forEach((el, index) => {
      setTimeout(() => {
        this.renderer.setStyle(el, 'opacity', '1');
        this.renderer.setStyle(el, 'transform', 'translateY(0)');
      }, 200 * index);
    });
  }

  navigateToHome(fragment: string) {
    this.router.navigate(['/'], { fragment: fragment });
  }
}
